$(function(){
	if($('ul.menu').length){
		$('ul.menu').clone().appendTo('.offcanvas-footer');
	}
});